import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
} from "date-fns";

const defineds = {
  startOfNext3Days: startOfDay(addDays(new Date(), 1)),
  endOfNext3Days: endOfDay(addDays(new Date(), 3)),
  startOfNext5Days: startOfDay(addDays(new Date(), 1)),
  endOfNext5Days: endOfDay(addDays(new Date(), 5)),
  startOfNextWeek: startOfWeek(addDays(new Date(), 7)),
  endOfNextWeek: endOfWeek(addDays(new Date(), 7)),
  startOfNextMonth: startOfMonth(addMonths(new Date(), 1)),
  endOfNextMonth: endOfMonth(addMonths(new Date(), 1)),
  startOfIn2Months: startOfMonth(addMonths(new Date(), 2)),
  endOfIn2Months: endOfMonth(addMonths(new Date(), 2)),
  startOfIn3Months: startOfMonth(addMonths(new Date(), 3)),
  endOfIn3Months: endOfMonth(addMonths(new Date(), 3)),
};

const staticRangeHandler = {
  range: {},
  isSelected(range: any) {
    /* @ts-ignore */
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  },
};

export function createStaticRanges(ranges: any) {
  return ranges.map((range: any) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = createStaticRanges([
  {
    label: "In 3 Days",
    range: () => ({
      startDate: defineds.startOfNext3Days,
      endDate: defineds.endOfNext3Days,
    }),
  },
  {
    label: "In 5 Days",
    range: () => ({
      startDate: defineds.startOfNext5Days,
      endDate: defineds.endOfNext5Days,
    }),
  },
  {
    label: "In a Week",
    range: () => ({
      startDate: defineds.startOfNextWeek,
      endDate: defineds.endOfNextWeek,
    }),
  },
  {
    label: "In a Month",
    range: () => ({
      startDate: defineds.startOfNextMonth,
      endDate: defineds.endOfNextMonth,
    }),
  },
  {
    label: "In 2 Months",
    range: () => ({
      startDate: defineds.startOfIn2Months,
      endDate: defineds.endOfIn2Months,
    }),
  },
  {
    label: "In 3 Months",
    range: () => ({
      startDate: defineds.startOfIn3Months,
      endDate: defineds.endOfIn3Months,
    }),
  },
]);

export function getDifferenceInDays(date1: any, date2: any) {
  // Calculate the difference in milliseconds
  const differenceInMillis = date2 - date1;

  // Convert milliseconds to days
  const differenceInDays = differenceInMillis / (1000 * 60 * 60 * 24);

  // Return the difference rounded to the nearest whole number
  return Math.round(differenceInDays);
}
